import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const GetAllJenisPembiayaanDropdown = createAsyncThunk(
  "jenisPembiayaan/GetAllJenisPembiayaanDropdown",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}master/jenis_pembiayaan`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllJenisPembiayaan = createAsyncThunk(
  "jenisPembiayaan/GetAllJenisPembiayaan",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}master/jenis_pembiayaan/all?${data.url}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleJenisPembiayaan = createAsyncThunk(
  "jenisPembiayaan/GetSingleJenisPembiayaan",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/jenis_pembiayaan/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const layananSlice = createSlice({
  name: "jenis_pembiayaan",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all jenis pembiayaan
    builder.addCase(GetAllJenisPembiayaanDropdown.pending, loadingHandler);
    builder.addCase(GetAllJenisPembiayaanDropdown.fulfilled, fulfilledHandler);
    builder.addCase(GetAllJenisPembiayaanDropdown.rejected, rejectedHandler);
    // get all jenis pembiayaan
    builder.addCase(GetAllJenisPembiayaan.pending, loadingHandler);
    builder.addCase(GetAllJenisPembiayaan.fulfilled, fulfilledHandler);
    builder.addCase(GetAllJenisPembiayaan.rejected, rejectedHandler);
    // get Single jenis pembiayaan
    builder.addCase(GetSingleJenisPembiayaan.pending, loadingHandler);
    builder.addCase(GetSingleJenisPembiayaan.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleJenisPembiayaan.rejected, rejectedHandler);
  },
});

export const { reset } = layananSlice.actions;
export default layananSlice.reducer;
